var indentation_default = {
  "indentZero": "_9Osz5",
  "indentOne": "_5nhsg",
  "indentTwo": "pERST",
  "indentThree": "knwiX",
  "indentFour": "x44Mg",
  "indentFive": "VCLRm",
  "indentSix": "ivo-p"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
